<template>
  <section>
    <el-row class="selectRow">
      <el-col>
        <el-row :gutter="10">
          <el-select class="xs24" v-model="pdata.issued_app_id" filterable  clearable placeholder="请输入发行游戏名称">
	        	<el-option v-for="(item,i) in PlacementList" :key="item.issued_app_id" :label="item.name" :value="item.issued_app_id"></el-option>
		      </el-select>
		      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
	      	<el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
	          
        </el-row>
      </el-col>
    </el-row>
    
  

    <!--列表-->
    <el-table
      ref="multipleTable"
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
       @sort-change="tableSort"
    >
      <el-table-column type="selection"></el-table-column>
       <el-table-column prop="issued_app_id" label="ID" min-width="80px" align="center"></el-table-column> 
      <el-table-column prop="name" label="流量主游戏名称" align="left" min-width="120px">
        <template slot-scope="scope">
          <el-button type="text" @click="$router.push({name:'创意投放',params:{issued_app_id:scope.row.issued_app_id}})" >{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
       <el-table-column prop="version" label="版本号" align="left" min-width="120px">
        <template slot-scope="scope">
        
        	<div v-if="scope.row.isVerson==true">
        		 <el-input @keyup.enter.native="saveVersion(scope,scope.$index)" v-model="plist[scope.$index].version" style="width:70px;display: inline-block;" > </el-input>
        		 <i class="el-icon-upload " @click="saveVersion(scope,scope.$index)"  style="cursor: pointer;">保存</i>
        	</div>
        	<div v-if="scope.row.isVerson==false" class="editBox">
        		<span>{{scope.row.version}}</span > <i class="el-icon-edit icon_edit" @click="editVersion(scope.$index)"  style="cursor: pointer;"></i>
        	</div>
          
          
        </template>
      </el-table-column>
      <el-table-column prop="has_jump" label="是否含二跳" align="center">
      	<template slot-scope="scope">
          <span v-if="scope.row.has_jump==1">是</span><span v-else>否</span>
       </template>
      </el-table-column>
      <el-table-column prop="product_num" label="产品数量" align="center"></el-table-column>
      <el-table-column prop="creative_num" label="创意数量" align="center">
      	 <template slot-scope="scope">
          <span :class="scope.row.creative_num.online!=scope.row.creative_num.count?'red':''">{{scope.row.creative_num.online}}/{{scope.row.creative_num.count}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="space_num" label="广告位" align="center">
      	 <template slot-scope="scope">
           <span v-if="scope.row.space_num.count>0" :class="scope.row.space_num.online!=scope.row.space_num.count?'red':''">{{scope.row.space_num.online}}/{{scope.row.space_num.count}}</span>
           <span v-if="scope.row.space_num.count==0">待接入广告位</span>
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" align="center" sortable="custom" min-width="110px"></el-table-column>
      <el-table-column prop="start_time" label="发行游戏状态" align="center">
      	 <template slot-scope="scope">
          <span>{{scope.row.status=='1'?'正常':'禁用'}}</span>
          
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" align="center" width="220px">
      	<template slot-scope="scope">
		      	<el-button
		            size="mini"
		            :type="scope.row.status=='1'?'success':'danger'"
		            @click="editStatus(scope.row)"
		          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
		       <el-button type="text"  @click="$router.push({name:'广告投放日志',params:{index_id:scope.row.id},query:{type:'plan'}})">更新日志</el-button>  
           <el-button size="mini" type="text" @click="$router.push({name:'广告位',params:{issued_app_id:scope.row.issued_app_id}})">广告位管理</el-button>
        </template>
      </el-table-column>




      
    
    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
  

    

   
   
  </section>
</template>

<script>
import {
  sadtou,
  getPlacementList,
  stoustatus,
  sclog,
  savePlanVersion
} from "../../api/api";
import transwin from "../../components/global/TransWin2.vue";

export default {
  components: {
    transwin
  },
  data() {
    return {
      rules: {
        issued_app_id: [
          { required: true, message: "请选择投放小程序", trigger: "blur" }
        ],
        space_ids: [
          { required: true, message: "请选择广告位", trigger: "change" }
        ]
      },
      plog: [],
      logDialog: false,
      pdata: {
        page: 1,
        perpage: 20,
        kw: "",
        sort_field:"",
        create_time:"",
        sort_by:"",
      },
      plist: [],
      PlacementList:[],
      maxPage: 1,
       cP: {
        index_id: "",
        status: "1",
        log: ""
      },
    };
  },
  watch: {
     "pdata.issued_app_id": {
      handler(n, o) {
        this.getList();
      },
      deep: true
    },
     'pdata.sort_by': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
  },
  methods: {
  	  	tableSort(e){
  		
	  			this.pdata.sort_field=e.prop;
	  			if(e.order=="ascending"){
	  				this.pdata.sort_by="asc"
	  				
	  			}
	  			else if(e.order=="descending"){
	  				this.pdata.sort_by="desc"
	  			}
	  			else{
	  				this.pdata.sort_by="";
	  				this.pdata.sort_field="";
	  			}
	  		
	  		
	  	},
	  	editVersion(index){
	  		
	  		this.plist[index].isVerson=true;
	  		this.$forceUpdate();
	  	},
	  	saveVersion(s,index){
	  		savePlanVersion({"index_id":s.row.id,"version":this.plist[index].version}, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.$message({ message:"保存成功", type: "success" });
	          this.getList();
	        } else {
	          this.$message.error(res.msg);
	        }
	      });
	  	},
  	 
  	  openDealy(id) {
  	 	var p = 'type=plan&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog2 = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sadtou(p, this.$cookie.getCookie("login")).then(res => {
      
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		res.data.list.forEach((v,i)=>{
        			v.isVerson=false;
        		})
        		this.plist = res.data.list;
          	this.maxPage = res.data.max_page;
        	}
        	else{
        		this.plist = [];
        		this.maxPage = 1;
        	}
        
        }
      });
    },
    getPlacements(){
    	getPlacementList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.PlacementList = res.data.list;
          
        }
      });
    },
    
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    
    editStatus(s) {
      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
     this.$confirm(p.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(() => {
        stoustatus(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
          }
        });
      });
    },



    changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
	      stoustatus(this.cP, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.getList();
	          this.$message({ message: this.cP.log + "成功", type: "success" });
	        }
	      });
      })
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },


  },

  mounted() {
    this.getList();
    this.getPlacements();

  }
};
</script>

<style scoped lang="scss">
.editBox:hover .icon_edit{
	display:inline;
}
.icon_edit{
	display: none;
}
.text {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  font-weight: 500;
}
.gImg {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  border-radius: 8px;
}
</style>





// WEBPACK FOOTER //
// ADdelivery.vue?7ae961ac